import { render, staticRenderFns } from "./ItemBrowser.vue?vue&type=template&id=3424aa1c&"
import script from "./ItemBrowser.vue?vue&type=script&lang=js&"
export * from "./ItemBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports